import { cn } from "@/lib/utils";

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={cn("flex items-center gap-1.5 md:gap-2 font-bold text-xl md:text-2xl tracking-tight shrink-0", className)}>
      <div className="flex h-7 w-7 md:h-8 md:w-8 items-center justify-center rounded-full bg-primary text-primary-foreground shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4 md:h-5 md:w-5"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <span className="text-foreground">
        Uplevel <span className="text-primary">Cleaning</span>
      </span>
    </div>
  );
};
